import { jsx as _jsx } from "react/jsx-runtime";
import { StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { Row } from '../../atoms';
export function NavBarButtons({ children }) {
    return _jsx(Row.R, { style: $.container, children: children });
}
const $ = StyleSheet.create({
    container: { gap: theme.spacing['2'] },
});
